import { useEffect } from "react";

const ResumePreview = ({ resumeData }) => {
	useEffect(() => {}, [resumeData]);
	return (
		<div className="resume-scope" style={{ scale: "1.2", transformOrigin: "center" }}>
			<div className="small-resume-preview">
				<div className="final-resume-preview bg-white  text-gray-800">
					<div className="resume-content ">
						<div className="top">
							<div className="flex flex-wrap no-wrap">
								<div
									className="w-1/3 py-2 border-r"
									style={{
										backgroundColor: "rgb(248, 249, 250)",
									}}
								>
									<div className="resume-pic mx-auto flex items-center justify-center">
										<p className="font-weight-semi m-0">
											{resumeData.contactInfo.firstName.charAt(0)}
											{resumeData.contactInfo.lastName.charAt(0)}
										</p>
									</div>
								</div>
								<div className="w-2/3 px-2 py-2">
									<div className="resume-user-name">
										<h1
											className="uppercase"
											style={{
												whiteSpace: "nowrap",
												overflow: "hidden",
												textOverflow: "ellipsis",
												margin: "0",
											}}
										>
											{resumeData.contactInfo.firstName} {resumeData.contactInfo.middleName}{" "}
											{resumeData.contactInfo.lastName}
										</h1>
										<span
											className="inline-block"
											style={{
												height: "2px",
												backgroundColor: "#03a9f4",
												width: "100px",
											}}
										/>
									</div>
									<ul
										style={{ fontSize: "4.5px" }}
										className="resume-user-quick-info flex list-none p-0 items-center mb-0"
									>
										<li className="mr-1 whitespace-nowrap">
											<span className="span text-blue-500 mr-1 fa fa-map-marker" /> {resumeData.contactInfo.city},{" "}
											{resumeData.contactInfo.country}
										</li>
										<li className="mr-1 whitespace-nowrap">
											<span className="span text-blue-500 mr-1 fa fa-phone" />
											{resumeData.contactInfo.phoneNo}
										</li>
										<li className="mr-1 whitespace-nowrap">
											<span className="span text-blue-500 mr-1 fa fa-envelope" />
											{resumeData.contactInfo.email}
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="bottom">
							<div className="flex flex-wrap">
								<div className="w-1/3 border-r px-2" style={{ backgroundColor: "#f8f9fa" }}>
									<div className="contact-info my-4">
										<h3 className="uppercase">CONTACT</h3>
										<ul className="list-none p-0">
											<li>Dar es Salaam, Tanzania </li>
											<li>
												<span className="font-bold">Mobile:</span> 9999999999
											</li>
											<li>
												<span className="font-bold">Email</span>
												test@email.com
											</li>
										</ul>
									</div>
									<div className="personal-links my-4">
										<h3 className="uppercase">website, portfolio, profiles</h3>
										<ul className="pl-4 mb-1">
											<li>Dar es Salaam, Tanzania </li>
											<li>
												<span className="font-bold">Mobile:</span> 9999999999
											</li>
											<li>
												<span className="font-bold">Email</span>
												test@email.com
											</li>
										</ul>
									</div>
									<div className="education-info my-4">
										<h3 className="uppercase">Education</h3>
										<ul className="pl-4 mb-1">
											<li>January, 2020</li>
											<li>Bachelor of Science: Computer Applications</li>
											<li>
												<span className="font-bold">Central School</span>Dar es Salaam
											</li>
										</ul>
									</div>
									<div className="certifications-info my-4">
										<h3 className="uppercase">Certifications</h3>
										<ul className="pl-4 mb-1">
											<li>Certified Associate Webmaster</li>
											<li>MCPD - Microsoft Certified Professional Developer</li>
										</ul>
									</div>
									<div className="languages-info my-4">
										<h3 className="uppercase">Languages</h3>
										<ul className="list-none p-0">
											<li>Dar es Salaam, Tanzania </li>
											<li>
												<span className="font-bold">Mobile:</span> 9999999999
											</li>
											<li>
												<span className="font-bold">Email</span>
												test@email.com
											</li>
										</ul>
									</div>
								</div>
								<div className="w-2/3 px-2">
									<div className="professional-summary-info my-1">
										<h3 className="uppercase with-circle">Professional Summary</h3>
										<p>
											Tech-savvy Web Developer contributes specialty in search engine optimization, marketing, social
											media management and audio/video integration to launch custom-tailored code for website
										</p>
									</div>
									<div className="languages-info my-1">
										<h3 className="uppercase  with-circle">Accomplishments</h3>
										<ul className="pl-4 mb-1">
											<li>
												Spearheaded a large-scale client project as a result of skill set and education and completed
												the project two weeks ahead of schedule.
											</li>
										</ul>
									</div>
									<div className="skills-info my-1">
										<h3 className="uppercase  with-circle">Skills</h3>
										<ul className="pl-4 mb-1">
											<li>Version Control Systems: Git, Github</li>
											<li>Complex Problem Solving</li>
											<li>Communication and Interpersonal Skills</li>
										</ul>
									</div>
									<div className="work-history-info my-1">
										<h3 className="uppercase  with-circle" />
										<p className="mb-0">August, 2019 - May, 2021</p>
										<p className="mb-2">
											<strong>Web Developer</strong>, <em>Kellton Tech</em>, Dar es Salaam, Tanzania{" "}
										</p>
										<ul className="pl-4 mb-1">
											<li>
												Planned website development, converting mockups into usable web presence with HTML, JavaScript,
												AJAX and JSON coding.
											</li>
										</ul>
									</div>
									<div className="affliations-info my-1">
										<h3 className="uppercase with-circle">Affiliations</h3>
										<ul className="pl-4 mb-1">
											<li> Association for Computing Machinery</li>
											<li>Freemason</li>
											<li>Toastmasters</li>
										</ul>
									</div>
									<div className="addtional-info my-1">
										<h3 className="uppercase with-circle">Additonal Information</h3>
										<p>
											Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
											the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley
											.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResumePreview;
